<template>
    <div style="display: flex;flex-direction: column ; gap: 25px !important;">
        <div class="flex items-center justify-between mt-10 ">
            <CategoryBadge :category="category" />

            <ActionButtons
                @share="$emit('share')"
            />
        </div>

        <h1 class="text-6xl font-serif text-[#2A4493] mb-4">{{ title }}</h1>

        <PublishInfo
            :published-date="formatDate(publishedDate)"
            :author="author"
        />
    </div>
</template>

<script setup>


import CategoryBadge from "@/vue/Public/event/detail/CategoryBadge.vue";
import ActionButtons from "@/vue/Public/event/detail/ActionButtons.vue";
import PublishInfo from "@/vue/Public/event/detail/PublishInfo.vue";

defineProps({
    category: String,
    title: String,
    publishedDate: String,
    author: String,
    isLiked: Boolean
})

defineEmits(['share'])
const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR')
}
</script>
